// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2h5Qn","footer":"ModalUpdate_footer__6dfVV"};